import React, { useRef, useEffect } from 'react';

export default function GenModal(props) {
  const modalRef = useRef(null);
  const lastFocusedElement = useRef(null);

  // Helper to get all focusable elements inside the modal
  const getFocusableElements = () => {
    if (!modalRef.current) return [];
    const focusableEls = modalRef.current.querySelectorAll(
      'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    const customTabEls = modalRef.current.querySelectorAll('[tabindex="0"]');
    return Array.from(new Set([...focusableEls, ...customTabEls]));
  };

  useEffect(() => {
    if (props.open) {
      lastFocusedElement.current = document.activeElement;
      // Focus the first focusable element, or the modal itself as fallback
      const focusable = getFocusableElements();
      if (focusable.length > 0) {
        focusable[0].focus();
      } else if (modalRef.current) {
        modalRef.current.focus();
      }

      // Trap focus globally while modal is open
      const handleKeyDown = (e) => {
        if (e.key === 'Tab') {
          const focusable = getFocusableElements();
          if (focusable.length === 0) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (e.shiftKey) {
            if (document.activeElement === first || document.activeElement === modalRef.current) {
              e.preventDefault();
              last.focus();
            }
          } else {
            if (document.activeElement === last || document.activeElement === modalRef.current) {
              e.preventDefault();
              first.focus();
            }
          }
        }
      };
      document.addEventListener('keydown', handleKeyDown, true);
      return () => {
        document.removeEventListener('keydown', handleKeyDown, true);
      };
    } else if (lastFocusedElement.current) {
      lastFocusedElement.current.focus();
    }
  }, [props.open]);

  if (props.open) {
    return (
      <div
        className="gen-modal"
        ref={modalRef}
        aria-modal="true"
        role="dialog"
        tabIndex={-1}
        style={{outline: 'none'}}
      >
        {props.children}
      </div>
    );
  } else {
    return null;
  }
}
